/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Routemize_Core_Dtos_PagedResultDto_1 } from '../models/Routemize_Core_Dtos_PagedResultDto_1';
import type { Routemize_DTOs_Metadata_CreateNoteDTO } from '../models/Routemize_DTOs_Metadata_CreateNoteDTO';
import type { Routemize_DTOs_Metadata_EntityNoteDTO } from '../models/Routemize_DTOs_Metadata_EntityNoteDTO';
import type { Routemize_DTOs_Metadata_EntityNoteDTO_Routemize_Application_Contracts_Version_1_0_0_0_Culture_neutral_PublicKeyToken_null_ } from '../models/Routemize_DTOs_Metadata_EntityNoteDTO_Routemize_Application_Contracts_Version_1_0_0_0_Culture_neutral_PublicKeyToken_null_';
import type { Routemize_DTOs_Metadata_NotesBundleDTO } from '../models/Routemize_DTOs_Metadata_NotesBundleDTO';
import type { Routemize_DTOs_Metadata_UpdateNoteDTO } from '../models/Routemize_DTOs_Metadata_UpdateNoteDTO';
import type { Routemize_Entities_Metadata_NotePriority } from '../models/Routemize_Entities_Metadata_NotePriority';
import type { Routemize_Entities_Metadata_NoteType } from '../models/Routemize_Entities_Metadata_NoteType';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class EntityNoteService {
    /**
     * @param entityId
     * @param entityType
     * @param type  Possible values: General = 0, Important = 1, FollowUp = 2, Meeting = 3, Call = 4, Email = 5, Internal = 6, CustomerFacing = 7, Customer = 8, StatusReason = 9
     * @param priority  Possible values: Low = 0, Normal = 1, High = 2, Urgent = 3
     * @param isPinned
     * @param sorting
     * @param skipCount
     * @param maxResultCount
     * @returns Routemize_Core_Dtos_PagedResultDto_1<Routemize_DTOs_Metadata_EntityNoteDTO_Routemize_Application_Contracts_Version_1_0_0_0_Culture_neutral_PublicKeyToken_null_> OK
     * @throws ApiError
     */
    public static getApiAppEntityNoteGetEntityNotes(
        entityId: string,
        entityType?: string,
        type?: Routemize_Entities_Metadata_NoteType,
        priority?: Routemize_Entities_Metadata_NotePriority,
        isPinned?: boolean,
        sorting?: string,
        skipCount?: number,
        maxResultCount?: number,
    ): CancelablePromise<Routemize_Core_Dtos_PagedResultDto_1> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/app/entityNote/getEntityNotes/{entityId}',
            path: {
                'entityId': entityId,
            },
            query: {
                'entityType': entityType,
                'Type': type,
                'Priority': priority,
                'IsPinned': isPinned,
                'Sorting': sorting,
                'SkipCount': skipCount,
                'MaxResultCount': maxResultCount,
            },
        });
    }
    /**
     * @param entityId
     * @param entityType
     * @param requestBody
     * @returns Routemize_DTOs_Metadata_EntityNoteDTO OK
     * @throws ApiError
     */
    public static postApiAppEntityNoteCreateNote(
        entityId: string,
        entityType?: string,
        requestBody?: Routemize_DTOs_Metadata_CreateNoteDTO,
    ): CancelablePromise<Routemize_DTOs_Metadata_EntityNoteDTO> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/app/entityNote/createNote/{entityId}',
            path: {
                'entityId': entityId,
            },
            query: {
                'entityType': entityType,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param noteId
     * @param requestBody
     * @returns Routemize_DTOs_Metadata_EntityNoteDTO OK
     * @throws ApiError
     */
    public static putApiAppEntityNoteUpdateNote(
        noteId: string,
        requestBody?: Routemize_DTOs_Metadata_UpdateNoteDTO,
    ): CancelablePromise<Routemize_DTOs_Metadata_EntityNoteDTO> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/app/entityNote/updateNote/{noteId}',
            path: {
                'noteId': noteId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param noteId
     * @returns any OK
     * @throws ApiError
     */
    public static deleteApiAppEntityNoteDeleteNote(
        noteId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/app/entityNote/deleteNote/{noteId}',
            path: {
                'noteId': noteId,
            },
        });
    }
    /**
     * @param noteId
     * @returns Routemize_DTOs_Metadata_EntityNoteDTO OK
     * @throws ApiError
     */
    public static postApiAppEntityNoteTogglePinNote(
        noteId: string,
    ): CancelablePromise<Routemize_DTOs_Metadata_EntityNoteDTO> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/app/entityNote/togglePinNote/{noteId}',
            path: {
                'noteId': noteId,
            },
        });
    }
    /**
     * @param entityId
     * @param entityType
     * @returns number OK
     * @throws ApiError
     */
    public static getApiAppEntityNoteGetNotesCount(
        entityId: string,
        entityType?: string,
    ): CancelablePromise<number> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/app/entityNote/getNotesCount/{entityId}',
            path: {
                'entityId': entityId,
            },
            query: {
                'entityType': entityType,
            },
        });
    }
    /**
     * @param entityId
     * @param entityType
     * @returns Routemize_DTOs_Metadata_EntityNoteDTO OK
     * @throws ApiError
     */
    public static getApiAppEntityNoteGetLatestNote(
        entityId: string,
        entityType?: string,
    ): CancelablePromise<Routemize_DTOs_Metadata_EntityNoteDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/app/entityNote/getLatestNote/{entityId}',
            path: {
                'entityId': entityId,
            },
            query: {
                'entityType': entityType,
            },
        });
    }
    /**
     * @param noteIds
     * @returns any OK
     * @throws ApiError
     */
    public static deleteApiAppEntityNoteDeleteMultipleNotes(
        noteIds?: Array<string>,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/app/entityNote/deleteMultipleNotes',
            query: {
                'noteIds': noteIds,
            },
        });
    }
    /**
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static postApiAppEntityNotePinMultipleNotes(
        requestBody?: Array<string>,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/app/entityNote/pinMultipleNotes',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static postApiAppEntityNoteUnpinMultipleNotes(
        requestBody?: Array<string>,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/app/entityNote/unpinMultipleNotes',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param entityId
     * @param entityType
     * @param noteType  Possible values: General = 0, Important = 1, FollowUp = 2, Meeting = 3, Call = 4, Email = 5, Internal = 6, CustomerFacing = 7, Customer = 8, StatusReason = 9
     * @returns Routemize_DTOs_Metadata_EntityNoteDTO OK
     * @throws ApiError
     */
    public static getApiAppEntityNoteGetNotesByType(
        entityId: string,
        entityType?: string,
        noteType?: Routemize_Entities_Metadata_NoteType,
    ): CancelablePromise<Array<Routemize_DTOs_Metadata_EntityNoteDTO>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/app/entityNote/getNotesByType/{entityId}',
            path: {
                'entityId': entityId,
            },
            query: {
                'entityType': entityType,
                'noteType': noteType,
            },
        });
    }
    /**
     * @param entityId
     * @param entityType
     * @param priority  Possible values: Low = 0, Normal = 1, High = 2, Urgent = 3
     * @returns Routemize_DTOs_Metadata_EntityNoteDTO OK
     * @throws ApiError
     */
    public static getApiAppEntityNoteGetNotesByPriority(
        entityId: string,
        entityType?: string,
        priority?: Routemize_Entities_Metadata_NotePriority,
    ): CancelablePromise<Array<Routemize_DTOs_Metadata_EntityNoteDTO>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/app/entityNote/getNotesByPriority/{entityId}',
            path: {
                'entityId': entityId,
            },
            query: {
                'entityType': entityType,
                'priority': priority,
            },
        });
    }
    /**
     * @param entityId
     * @param entityType
     * @returns Routemize_DTOs_Metadata_EntityNoteDTO OK
     * @throws ApiError
     */
    public static getApiAppEntityNoteGetPinnedNotes(
        entityId: string,
        entityType?: string,
    ): CancelablePromise<Array<Routemize_DTOs_Metadata_EntityNoteDTO>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/app/entityNote/getPinnedNotes/{entityId}',
            path: {
                'entityId': entityId,
            },
            query: {
                'entityType': entityType,
            },
        });
    }
    /**
     * @param appointmentId
     * @returns Routemize_DTOs_Metadata_NotesBundleDTO OK
     * @throws ApiError
     */
    public static getApiAppEntityNoteGetAppointmentNotesBundle(
        appointmentId: string,
    ): CancelablePromise<Routemize_DTOs_Metadata_NotesBundleDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/app/entityNote/getAppointmentNotesBundle/{appointmentId}',
            path: {
                'appointmentId': appointmentId,
            },
        });
    }
    /**
     * @param requestId
     * @returns Routemize_DTOs_Metadata_NotesBundleDTO OK
     * @throws ApiError
     */
    public static getApiAppEntityNoteGetRequestNotesBundle(
        requestId: string,
    ): CancelablePromise<Routemize_DTOs_Metadata_NotesBundleDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/app/entityNote/getRequestNotesBundle/{requestId}',
            path: {
                'requestId': requestId,
            },
        });
    }
}
